// Shared constants/types for the flagged-spots writer-launch prompt.

/**
 * Display name of the tag that drives the prompt. The prompt resolves this name to the
 * tag's id from the registry, so it must stay in sync with the tag's name in the Tag
 * Manager — if you rename the tag there, update this constant too.
 */
export const FLAGGED_SPOTS_TAG_NAME = 'לעבוד על זה'

/** Source file the author keeps loose fragments in (the רשומון); the dialog offers a direct jump to it. */
export const FLAGGED_SPOTS_JOURNAL_FILENAME = 'רשומון'

/** One flagged spot to revisit, resolved to a navigable location. */
export interface FlaggedSpotItem {
  filename: string
  /** Block to scroll to; null for file-level tags (jump to the file top). */
  blockId: string | null
  /** Section heading, or the file title for unsectioned files like the רשומון. */
  title: string
  /** Snippet of the tagged text, so the author can recognise the spot. */
  snippet: string
  /** Ancestor heading labels above the section, outermost first. */
  context: string[]
}
